<template>
  <div
    class="search-container"
    :class="{ 'search-container-active': searchIsActive }">

    <div
      v-show="searchIsActive && false"
      class="search-options">
      <div
        class="option"
        :class="{
          'option-active': searchAllCollections
        }"
        @click="handleOptionClick({ searchAllCollections: !searchAllCollections })">
        <i
          class="mdi mdi-12px"
          :class="{
            'mdi-close': !searchAllCollections,
            'mdi-check': searchAllCollections
          }" />
        all collections
      </div>
      <div
        class="option"
        :class="{
          'option-active': searchChildCollections
        }"
        @click="handleOptionClick({ searchChildCollections: !searchChildCollections })">
        <i
          class="mdi mdi-12px"
          :class="{
            'mdi-close': !searchChildCollections,
            'mdi-check': searchChildCollections
          }" />
        child collections
      </div>
      <div
        v-show="false"
        class="option"
        :class="{
          'option-active': matchAllTerms
        }"
        @click="handleOptionClick({ matchAllTerms: !matchAllTerms })">
        <i
          class="mdi mdi-12px"
          :class="{
            'mdi-close': !matchAllTerms,
            'mdi-check': matchAllTerms
          }" />
        match all terms
      </div>
    </div>

    <div
      class="search-bar">
      <div
        class="icon search-icon"
        :class="{
          'search-icon-active': searchIsActive
        }"
        @click="handleIconClick">
        <i class="mdi"
           :class="{
             'mdi-magnify': !searchIsActive,
             'mdi-close': searchIsActive,
           }" />
      </div>
      <input
        v-model="searchTerms"
        class="search-input"
        ref="searchInput"
        @focus="searchBarFocused"
        @blur="searchBarBlurred"
        :placeholder="placeholder" />
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'SearchBar',
  data() {
    return {
      searchTerms: null,
      optionClicked: false,
    };
  },
  computed: {
    ...mapState({
      searchIsActive: state => state.appState.search.isActive,
      matchAllTerms: state => state.search.matchAllTerms,
      searchAllCollections: state => state.search.searchAllCollections,
      searchChildCollections: state => state.search.searchChildCollections,
      selectedCollection: state => state.collections.selectedCollection,
    }),
    searchTermsArray() {
      if (this.searchTerms) return this.searchTerms.split(' ');
      return [];
    },
    searchBarIcon() {
      if (this.searchTerms) return 'close';
      return 'magnify';
    },
    placeholder() {
      return 'Search items';
    },
  },
  methods: {
    ...mapActions({
      setSearchState: 'appState/setSearchState',
      setSearchParams: 'search/setSearchParams',
    }),
    searchBarBlurred() {
      if (!this.searchTermsArray.length) this.setSearchState({ isActive: false, displayResults: false });
    },
    async searchBarFocused(e) {
      if (this.$route.name.includes('Note')) {
        e.target.blur();
        return;
      }

      // Search results only display in CollectionView, so navigate there if necessary
      if (this.$route.name === 'Card') this.$goToCollection({ id: this.selectedCollection });

      this.setSearchState({ isActive: true, displayResults: true });
      if (this.searchTerms) this.setSearchParams({ terms: this.searchTermsArray });
    },
    handleIconClick() {
      this.searchTerms = null;
      this.setSearchState({ isActive: false, displayResults: false });
    },
    handleOptionClick(payload) {
      this.setSearchParams(payload);
      this.optionClicked = true;
      this.$refs.searchInput.focus();
    },
    handleKeydown(event) {
      if (event.key === 'Escape') this.searchTerms = null;
    },
  },
  mounted() {
    this.$refs.searchInput.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    this.$refs.searchInput.removeEventListener('keydown', this.handleKeydown);
  },
  watch: {
    searchTermsArray() {
      this.setSearchParams({ terms: this.searchTermsArray });
    },
    selectedCollection() {
      this.setSearchState({ isActive: false, displayResults: false });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/colors';

.search-container {
  // margin: auto;
  // padding-top: 0.25rem;
  margin-top: 0.25rem;
  height: calc(100% - 0.5rem);
  color: $black;
  background: rgba($primary, 0.75);
  background: $lightgrey;
  border-radius: 0.25rem;
}
.search-container-active {
  background: $primary-light;
  box-shadow: 0 0 3px 1.5px $primary;
}
.search-bar {
  flex-basis: auto;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  transition: all 0.2s;
  // border: calc(0.35vh - 1px) solid darken($primary-dark, 15);
  width: calc(30vw + 1.5rem);
  height: 100%;
  margin-left: 0.5rem;
}
.search-input {
  background: transparent;
  padding: 0.15rem;
  padding-left: 0.25rem;
  border: 0px;
  // border-bottom: 1px solid $primary-dark;
  outline: none;
  width: 30vw;
  font-style: italic;
  transition: all 0.3s;
}
.search-input::placeholder {
  opacity: 0.8;
  font-weight: 100;
}
.search-icon {
  cursor: default;
  opacity: 0.7;
  transition: opacity 0.2s;
  height: 100%;
}
.search-icon:hover {
  opacity: 1;
}
.search-icon-active {
  cursor: pointer;
}
.search-options {
  position: absolute;
  top: calc(1.75rem);
  overflow: hidden;
  background: $lightgrey;
  color: $black;
  display: flex;
  padding: 0 0.25rem 0.25rem;
  padding-left: 0.5rem;
  transition: all 0.3s;
  width: calc(30vw + 1.5rem + 0.5rem); // search input + icon + margin left
  // height: 2rem;
  opacity: 1;
  z-index: 150000000;
}
.option {
  font-size: 0.7rem;
  cursor: pointer;
  user-select: none;
  margin-right: 0.5rem;
}
.option .icon {
  height: 0.9rem;
}
.option i {
  opacity: 0.7;
  color: $red;
  font-size: 0.85rem;
  position: relative;
  top: 0.075rem; // account for difference in font-size icons and text
}
.option-active i {
  opacity: 1;
  color: $green;
}
</style>
